import SpinReportView from "./SpinReportView";
import { apiPath } from "../../Utils/apiPath";

const ActiveSpinReport = () => (
  <SpinReportView
    title="Active Spin Report"
    endpoint={apiPath.activespinreport}
    amountField="lossAmount"
    amountLabel="Loss Amount"
    fileName="active-spin-report"
  />
);

export default ActiveSpinReport;
